/**
 * OpenList 文件操作相关的工具函数
 */

import type { OpenListFileType } from "@/types/openlist"

/**
 * 将 OpenListFileType 转换为预览组件期望的文件扩展名
 */
export function convertFileTypeForPreview(openListFileType: string, fileName: string): string {
  // 首先尝试从文件名获取真实扩展名
  const extension = fileName.split('.').pop()?.toLowerCase()
  
  // 如果有扩展名，直接使用
  if (extension) {
    return extension
  }
  
  // 否则根据 OpenListFileType 映射到常见扩展名
  const typeMap: Record<string, string> = {
    'pdf': 'pdf',
    'word': 'docx',
    'excel': 'xlsx', 
    'ppt': 'pptx',
    'text': 'txt',
    'image': 'jpg',
    'video': 'mp4',
    'audio': 'mp3',
    'archive': 'zip',
    'unknown': 'file'
  }
  
  return typeMap[openListFileType] || 'file'
}

/**
 * 获取文件类型对应的图标配置
 */
export interface FileIconConfig {
  iconType: 'FileText' | 'FileSpreadsheet' | 'ImageIcon' | 'Video' | 'File'
  colorClass: string
}

export function getFileIconConfig(fileType: OpenListFileType): FileIconConfig {
  switch (fileType) {
    case 'pdf':
      return { iconType: 'FileText', colorClass: 'text-red-500' }
    case 'word':
      return { iconType: 'FileText', colorClass: 'text-blue-600' }
    case 'excel':
      return { iconType: 'FileSpreadsheet', colorClass: 'text-green-600' }
    case 'ppt':
      return { iconType: 'FileText', colorClass: 'text-orange-600' }
    case 'image':
      return { iconType: 'ImageIcon', colorClass: 'text-green-500' }
    case 'video':
      return { iconType: 'Video', colorClass: 'text-blue-500' }
    case 'audio':
      return { iconType: 'FileText', colorClass: 'text-purple-500' }
    case 'text':
      return { iconType: 'FileText', colorClass: 'text-gray-600' }
    case 'archive':
      return { iconType: 'File', colorClass: 'text-orange-500' }
    default:
      return { iconType: 'File', colorClass: 'text-gray-500' }
  }
}

/**
 * 格式化文件大小
 */
export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 B'
  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i]
}
